import React, { Component } from 'react';
import cx from 'classnames/bind';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Button from '../Button/Button';
import ContentRenderer from '../Renderers/ContentRenderer';
import List from './List';
import RadioButton from '../RadioButton/RadioButton';

const PAGE_SIZE = 25;
const ITEM_DATA = [
  {
    type: 'asset',
    imageUrl: 'https://images.unsplash.com/photo-1485872304698-0537e003288d?dpr=1&auto=format&fit=crop&w=168&h=112&q=80&cs=tinysrgb&crop=',
    title: 'Asset title',
    locked: true,
    tag: 'Draft',
  }, {
    type: 'category',
    imageUrl: 'https://images.unsplash.com/photo-1454942901704-3c44c11b2ad1?dpr=1&auto=format&fit=crop&w=168&h=112&q=80&cs=tinysrgb&crop=&bg=',
    title: 'Category title',
  }, {
    type: 'smart-list',
    imageUrl: 'https://images.unsplash.com/photo-1484542603127-984f4f7d14cb?dpr=1&auto=format&fit=crop&w=168&h=101&q=80&cs=tinysrgb&crop=&bg=',
    title: 'Statehood Movement Grows in Columbia - the follow up',
    description: 'VCC Team FTW',
    tag: 'Modified',
    linked: true,
    error: 'Required fields missing'
  }, {
    type: 'list',
    imageUrl: 'https://images.unsplash.com/photo-1485832329521-e944d75fa65e?dpr=1&auto=format&fit=crop&w=168&h=112&q=80&cs=tinysrgb&crop=&bg=',
    title: 'Bernie Sanders on Debbie Wasserman Schultz Resignation - she made the right decision for the future of the Democratic party',
    description: 'Vimond Media Solutions',
    footer: '2020-08-05 09:00:01',
    warning: 'Item is not published',
  }
];

class ListExample extends Component {

  constructor(props) {
    super(props);
    const RENDERERS = {
      Default: List.itemRenderer,
      Content: (item, index, listProps) => <ContentRenderer {...item} type={item.type} item={item} folder={item.type === 'smart-list' || item.type === 'list'} locked={item.locked} linked={item.linked} tag={item.tag} warning={item.warning} error={item.error} onCreateMenuItems={this.onCreateMenuItems} onCloseMenu={this.onCloseMenu}/>,
      Custom: (item, index) => <div className={cx('custom-renderer', { error: item.error, warning: item.warning })}><div className="inner"><h3>{item.title}</h3>{item.description && <p>{item.description}</p>}</div></div>,
    };
    this.state = {
      items: this.load(),
      itemRenderer: RENDERERS['Content'],
      selectionType: List.MULTIPLE,
      isFocused: true,
    };
    this.RENDERERS = RENDERERS;
  }

  onCloseMenu = () => (this.menuContext = undefined);

  onCreateMenuItems = item => {
    this.menuContext = item; // store menu context until it is closed
    return [
      <Button key="1">{`Menu item for type: ${item.type}`}</Button>,
      <Button key="2">Menu item 2</Button>
    ];
  };

  onChange = e => this.setState(e.target.value);

  onChangeRenderer = e => this.setState({ itemRenderer: this.RENDERERS[e.target.getAttribute('data-key')] });

  onSelectionChanged = items => this.setState({ items });

  load = (length = 0) => {
    const items = [];

    for (let i = length; i < PAGE_SIZE + length; i++) {
      items.push({
        ...ITEM_DATA[i % 4],
        id: i,
      });
    }
    return items;
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={List.defaultProps} propTypes={List.propTypes} propValues={this.state}>
          <Tip>Changing the renderer will only affect how data is displayed. The data set is the same for all the renderers.</Tip>
        </Properties>
        <div className={this.state.multiColumn ? 'multicolumn-list-container' : 'list-container'}>
          <div className="renderers" title="Renderers">
            <h3>Example Renderers:</h3>
            {Object.keys(this.RENDERERS).map(key =>
              <RadioButton label={key} key={key} data-key={key} checked={this.state.itemRenderer === this.RENDERERS[key]} onChange={this.onChangeRenderer}/>
            )}
          </div>
          <List {...this.state} onSelectionChanged={this.onSelectionChanged}/>
        </div>
        <SourceCode querySelector=".list-example .core-list"/>
      </Example>
    );
  }

}

ListExample.tags = 'infinite scroll';

export default ListExample;
